export default __webpack_public_path__ + "static/media/small_signal_rf_ver1.05dd9df2.svg";